module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ee-Fb-Gb.0ae5ea19.png";